<mat-card appearance="outlined" class="mat-elevation-z2 w-min-50-vw p-1 text-center" style="width: 100%; box-sizing:border-box">
  <mat-card-title>
    <h2>Your login needs one more verification</h2>
  </mat-card-title>
  <mat-card-subtitle>
    <h3>Check your email and insert the security code</h3>
  </mat-card-subtitle>
  <mat-card-content>
    <mat-form-field style="width: 100% !important">
      <input type="text" autocomplete="off" matInput placeholder="Token" width="100%" [(ngModel)]="tokenText" />
    </mat-form-field>
    <mat-card-content>
      <button *ngIf="completed" (click)="onVerifyButtonClicked()" mat-button>Verify</button>
      <mat-spinner style="margin-left: 45%;" [diameter]="36" *ngIf="!completed"></mat-spinner>
      <mat-card-content>
        <button *ngIf="completed" (click)="onResendEmailButtonClicked()" [ngClass]="'link-button'">Get a new token</button>
      </mat-card-content>
    </mat-card-content>
  </mat-card-content>
</mat-card>
